import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const styles = {
  root: {
    flexGrow: 1
  }
};

class CenteredTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
  }

  handleChange = (event, value) => {
    if (value === 0) this.props.history.push("/eventos");
    if (value === 1) this.props.history.push("/vip");
    if (value === 2) this.props.history.push("/fotos");
    if (value === 3) this.props.history.push("/registro");
    // this.setState({value: value});
  };

  render() {
    //const { classes } = this.props;

    return (
      <Paper>
        <Tabs
          //value={this.state.value}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Eventos" />
          <Tab label="VIP" />
          <Tab label="Fotos" />
          <Tab label="Registro" />
        </Tabs>
      </Paper>
    );
  }
}

CenteredTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(CenteredTabs));
